module.exports = __webpack_public_path__ + "img/inactive-25.2ffc663e.svg";